const signIn = {
  "signin.not.a.member.ingress": "Not a member?",
  "signin.not.a.member.link": "Sign up",
  "signin.sign.up": "Sign up",
  "signin.sign.in": "Sign in",
  "signin.welcome": "Elevate your game. Achieve your best.",
  "signin.email.label": "Email",
  "signin.email.placeholder": "youremail@example.com",
  "signin.email.invalid": "Please enter a valid email address",
  "signin.password.label": "Password",
  "signin.password.placeholder": "Enter password",
  "signin.sign.in.button": "Sign in",
  "signin.forgot.password.ingress": "Forgot password?",
  "signin.forgot.password.link": "Reset password",
  "signin.password.reset.sent": "A reset password link has been sent. Check your email for the password reset link.",
};

const forgotPassword = {
  "forgot.password.title": "Forgot password",
  "forgot.password.ingress": "Enter the email address you used when you joined and we'll send you instructions to reset your password.",
  "forgot.password.email.label": "Email",
  "forgot.password.email.placeholder": "Your email address",
  "forgot.password.send.button": "Send instructions",
  "forgot.password.success.title": "Password reset instructions sent",
  "forgot.password.success.message":
    "We've sent you an email with instructions to reset your password. Please check your email and follow the link to continue.",
};

const signUp = {
  "signup.join.us": "Join Us",
  "signup.sign.up": "Sign up to Be Your Best",
  "signup.personal.details": "Personal details",
  "signup.security.details": "Security details",
  "signup.first.label": "First",
  "signup.first.placeholder": "First name",
  "signup.last.label": "Last",
  "signup.last.placeholder": "Last name",
  "signup.email.label": "Email",
  "signup.email.placeholder": "youremail@example.com",
  "signup.password.label": "Password",
  "signup.password.placeholder": "8+ characters",
  "signup.confirm.password.label": "Confirm password",
  "signup.confirm.password.placeholder": "Confirm password",
  "signup.sign.up.button": "Continue",
  "signup.already.a.member.ingress": "Already a member?",
  "signup.already.a.member.link": "Sign in",
  "signup.password.reset.sent": "A reset password link has been sent. Check your email for the password reset link.",
  "signup.accept-terms.label": "By signing up to Be Your Best, I agree to their {{terms}} and {{privacy}}.",
  "signup.accept-terms.terms.link.label": "Terms of Service",
  "signup.accept-terms.privacy.link.label": "Privacy Policy",
  "signup.accept-terms.terms.link.href.default": "https://www.beyourbest.com/terms",
  "signup.accept-terms.terms.link.href.demo": "https://www.beyourbest.com/be-your-best-trial-terms-conditions",
  "signup.accept-terms.privacy.link.href": "https://www.beyourbest.com/privacy",
  "signup.title.default": "Sign up to Be Your Best",
  "signup.title.demo": "Start Your 2-Day Trial",
  "signup.subtitle.default": "Elevate your game. Achieve your best.",
  "signup.subtitle.demo": "Experience Be Your Best with limited access for 2 days.",
  "signup.button.default": "Continue",
  "signup.button.demo": "Start Free Trial",
  "signup.full.version.ingress": "Want the full version?",
  "signup.full.version.link": "Sign up here",
  "signup.verify.title.default": "Welcome to Be Your Best",
  "signup.verify.title.demo": "Verify Your Trial Account",
  "signup.verify.subtitle.default": "You are creating an account for {{email}}",
  "signup.verify.subtitle.demo": "Almost there! Just verify your email to start your 2-day trial.",
  "signup.verify.description.default":
    "We have sent you an email about account verification. Please check your email and click the link to verify your account.",
  "signup.verify.description.demo": "We've sent you a verification email. Please check your inbox and click the link to activate your trial account.",
  "signup.verify.refresh.default": "Refresh Account",
  "signup.verify.refresh.demo": "I've verified my email",
  "signup.verify.resend.default": "Resend Email",
  "signup.verify.resend.demo": "Resend verification email",
  "signup.verify.signout.default": "Sign Out",
  "signup.verify.signout.demo": "Sign out",
};

const utils = {
  "utils.password.no.match": "Password does not match",
  "utils.password.min.length": "Password must be at least 8 characters long",
};

const paymentProductSelectionDialog = {
  "payment.product.selection.dialog.title.personal": "Personal",
  "payment.product.selection.dialog.title.business": "Business",
  "payment.product.selection.dialog.description.personal":
    "For individuals looking to enhance their performance with tailored training tools and insights",
  "payment.product.selection.dialog.description.business": "For organizations and teams seeking tailored solutions",
  "payment.product.selection.dialog.price.unit-per-interval": "{{ currency }} / mo.",
  "payment.product.selection.dialog.included-quantity": "{{ quantity }} seats included",
  "payment.product.selection.dialog.billed.year": "{{ price }} billed annually",
  "payment.product.selection.dialog.billed.month": "{{ price }} billed monthly",
};

const checkout = {
  "checkout.payment.billing-address-incomplete": "Please enter your complete billing address.",
  "checkout.payment.currency-updating": "Customers in Norway must pay in NOK. Please wait for pricing to update.",
  "checkout.subscription.promo.exlusive.error.gca": "This promo code can only be applied to a Yearly Membership.",
  "checkout.payment.heading": "Payment",
  "checkout.payment.billing-address": "Billing address",
  "checkout.payment.payment-details": "Payment details",
  "checkout.payment.body.1": "Fill out your card details and get started today.",
  "checkout.payment.body.2.1": "See our",
  "checkout.payment.body.2.2": "supported VR devices.",
  "checkout.payment.card.error": "An unexpected error occured. Please contact support.",
  "checkout.payment.currency-unavailable": "NOK pricing is currently unavailable. Please contact support to complete your purchase.",
  "checkout.payment.powered.by": "Powered by",
  "checkout.payment.provider": "Stripe",
  "checkout.payment.pay": "Pay {{ price }}",
  "checkout.payment.creating_confirmation_token": "Creating confirmation token",
  "checkout.payment.creating_subscription": "Creating subscription",
  "checkout.payment.finalizing_account": "Finalizing account",
  "checkout.payment.ending_demo_account": "Ending trial account",
  "checkout.error.unexpected": "An unexpected error occurred. Please refresh the page to try again or contact support.",
  "checkout.error.promo.code.invalid.generic": "Invalid promo code",
  "checkout.error.promo.code.invalid.subscription": "The {{promoCode}} promo code is not valid for the currently selected Subscription",
  "checkout.error.demo-account-ended-failed.title": "Failed to end your demo account",
  "checkout.error.demo-account-ended-failed.message": "Failed to end your demo account. Please contact support.",
  "payment.outstanding.invoice.dialog.title": "Outstanding Invoice",
  "payment.outstanding.invoice.dialog.description.default":
    "You have an outstanding invoice from a previous purchase attempt that needs to be paid before you can access the product.",
  "payment.outstanding.invoice.dialog.description.checkout":
    "It looks like you have already tried to purchase a subscription, but the payment failed. Please pay the outstanding invoice to continue.",
  "payment.outstanding.invoice.dialog.amount.label": "Amount Due",
  "payment.outstanding.invoice.dialog.instructions":
    "Click the button below to open the payment page in a new tab. After completing your payment, refresh this page and you'll be able to access the product.",
  "payment.outstanding.invoice.dialog.button.pay": "Pay Invoice",
  "payment.outstanding.invoice.dialog.button.cancel": "Cancel",
  "payment.outstanding.invoice.banner.title": "Outstanding Invoice",
  "payment.outstanding.invoice.banner.description": "You have an unpaid invoice of {{amount}} from a previous purchase attempt.",
  "payment.outstanding.invoice.banner.button.refresh": "Refresh page",
  "payment.outstanding.invoice.banner.button.pay": "View",
};

const updatePlan = {
  "update.plan.payment.method.card": "{{brand}} •••• {{last4}}",
  "update.plan.payment.method.card.expires": "Expires {{month}}/{{year}}",
  "update.plan.payment.method.link": "Stripe Link",
  "update.plan.payment.method.sepa": "SEPA Debit •••• {{last4}}",
  "update.plan.payment.method.bank": "Bank Account •••• {{last4}}",
  "update.plan.payment.method.unknown": "Unknown payment method",
};

const general = {
  "components.sign.out.button": "Sign out",
  "components.back.button": "Back",
};

const imageSection = {
  "image.section.martin.odegaard.quote":
    "Really fun, but hard work. No physical load. Thank you Be Your Best for helping me train my vision and decision making during my injury period.",
  "image.section.martin.odegaard.source.text": "Martin Odegaard",
  "image.section.martin.odegaard.source.subtext": "Arsenal",
  "image.section.martin.odegaard.source.caption": "via Instagram",

  "image.section.scan.rate.title": "28",
  "image.section.scan.rate.postfix": "%",
  "image.section.scan.rate.body":
    "The average increase in scan rate after 9 weeks of using Be Your Best. This often results in a greater number of successful forward passes, and is beneficial for improved possession control, scoring opportunities, and tactical flexibility.",

  "image.section.companion.app.title": "Companion App",
  "image.section.companion.app.body":
    "Follow your progress, compete on leaderboards, and master your skills. Our Companion app delivers comprehensive analytics and insights to help you elevate your game and cognitive skills.",

  "image.section.ben.osborn.quote":
    "Relating how many times a player scans to their number of successful forward passes is good. I really enjoyed it.",
  "image.section.ben.osborn.source.text": "Ben Osborn",
  "image.section.ben.osborn.source.subtext": "Sheffield United",
};

const survey = {
  "survey.help_us.title": "Help us improve",
  "survey.help_us.description": "Where have you heard about Be Your Best? You can select more than one option.",
  "survey.help_us.friends": "Friends / Family",
  "survey.help_us.news": "Read about you",
  "survey.help_us.other": "Other",
  "survey.help_us.instagram": "Instagram",
  "survey.help_us.tiktok": "TikTok",
  "survey.help_us.youtube": "Youtube",
  "survey.help_us.facebook": "Facebook",
  "survey.skip": "Skip",
};

const demoDiscontinued = {
  "demo.discontinued.title": "Trial No Longer Available",
  "demo.discontinued.description":
    "We appreciate your interest in Be Your Best. While our trial program is no longer available, we'd love to have you join our community with a full membership.",
  "demo.discontinued.already.member.ingress": "Already have an account?",
  "demo.discontinued.already.member.link": "Sign in",
  "demo.discontinued.not.member.ingress": "Ready to get started?",
  "demo.discontinued.not.member.link": "Sign up for full access",
};

const subscriptionPanel = {
  "subscription.menu.item.save.percent": "Save {{ percent }}%",
  "payment.subscription.panel.title.subscription": "Subscription",
  "payment.subscription.panel.button.view.details": "View details",
  "payment.subscription.panel.label.promo.code": "Promo code",
  "payment.subscription.panel.placeholder.promo.code": "Add promo code",
  "payment.subscription.panel.button.apply": "Apply",
  "payment.subscription.panel.button.remove": "Remove",
  "payment.subscription.panel.label.extra.seats": "Add extra seats",
  "payment.subscription.panel.subscription.label": "{{title}} Subscription",
  "payment.subscription.panel.text.monthly.breakdown": "{{price}} per month",
  "payment.subscription.panel.discount.duration.once": "first payment only",
  "payment.subscription.panel.discount.duration.repeating": "for a limited time",
  "payment.subscription.panel.discount.duration.forever": "for the lifetime of your subscription",
  "payment.subscription.panel.discount.tooltip": "This discount applies {{duration}}",
  "payment.subscription.panel.discount.savings": "You'll save {{amount}} per payment",
  "payment.subscription.panel.discount.description": "{{amount}} off {{duration}}",
  "payment.subscription.panel.discount.applied": "Promo code {{code}} applied",
  "payment.subscription.panel.discount.amount": "${{amount}} off",
  "payment.subscription.panel.discount.percent": "{{percent}}% off",
  "payment.subscription.panel.email.mismatch.title": "Signed in with a different email",
  "payment.subscription.panel.email.mismatch.message":
    "You are signed in as {{currentEmail}}, but this payment link was opened for {{linkEmail}}.",
  "payment.subscription.panel.button.continue.as": "Continue as {{email}}",
  "payment.subscription.panel.label.logged.in.email": "Signed in as",
  "payment.subscription.panel.renewal.info":
    "Your {{intervalText}} subscription will renew on {{renewalDate}}. The payment of {{price}} will cover your plan of {{quantity}} {{seats}}.",
  "payment.subscription.panel.text.seat": "seat",
  "payment.subscription.panel.text.seats": "seats",
  "payment.subscription.panel.text.interval.annual": "annual",
  "payment.subscription.panel.text.interval.monthly": "monthly",
  "payment.subscription.panel.price.per.month": "{{price}} / mo.",
};

export const purchaseFlow = {
  ...checkout,
  ...forgotPassword,
  ...general,
  ...imageSection,
  ...signIn,
  ...signUp,
  ...utils,
  ...updatePlan,
  ...paymentProductSelectionDialog,
  ...survey,
  ...subscriptionPanel,
  ...demoDiscontinued,
};
